import React from 'react';
import { Menu, Icon } from 'antd';
import { useDispatch } from 'react-redux';
import { resetFilter } from '../../store/actions';
import { notificationConstants } from '../../../../constants/notification.constants';
import styles from './FilterDropdownMenu.module.scss';

const FilterDropdownMenu = (props) => {
  const dispatch = useDispatch();

  const handleMenuClick = () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });
    dispatch(resetFilter());
  };

  return (
    <Menu {...props} onClick={handleMenuClick}>
      <Menu.Item>
        <Icon type="sync" className={styles.icon} />
        Сбросить
      </Menu.Item>
    </Menu>
  );
};

export default FilterDropdownMenu;
